import { combineReducers } from 'redux'

import { commonReducer } from '@app/store/common'
import { homeReducer } from '@app/store/homepage'
import { locationsReducer } from '@app/store/locations'
import { therapistsReducer } from '@app/store/therapists'
import { careersReducer } from '@app/store/careers'
import { learningStudioReducer } from '@app/store/learningStudio'
import { sessionReducer } from '@app/store/session'
import { costCalculatorReducer } from '@app/store/cost-calculator'
import { bookingReducer } from '@app/store/booking'
import { uiReducer } from '@app/store/ui'
import { notificationsReducer } from '@app/store/notifications'

export const rootReducer = combineReducers({
  common: commonReducer,
  locations: locationsReducer,
  homepage: homeReducer,
  therapists: therapistsReducer,
  careers: careersReducer,
  session: sessionReducer,
  costCalculator: costCalculatorReducer,
  learningStudio: learningStudioReducer,
  booking: bookingReducer,
  ui: uiReducer,
  notifications: notificationsReducer
})

export type AppState = ReturnType<typeof rootReducer>
